import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { getCookie } from "../../../../util/cookie/cookies";
export interface Props {scroll : any}
export const Section3:React.FC<Props> = ({scroll}) => {
    const lang = getCookie("HYUNDAILANG")
    const {t} = useTranslation()
    const navigate = useNavigate()
    return(
        <>
        <section className="mainSection_3" ref={(e)=>scroll.current[2]=e}>
            <div>
                <div className="left">
                    <h2>
                        <span>{t("main_section_5")}</span>
                        HET-ENGINE 3D
                    </h2>
                    {lang === 'kr' ? 
                    <p>
                        HET-Engine3D는 엔진 설치 후 원활한 유지보수관리를 위해 제작된 솔루션으로
                        <mark> 수명이 다 되어가는 부품 알림, 제품 사용연한 자동 알림, 관리 서류 등록, 부품 별
                        유지보수 관리 등의 고객의 요구에 맞는 다양한 관리 기능을 제공</mark>하여 시기를 놓치지
                        않고, 제때 관리하여 오랫동안 제품을 사용할 수 있도록 하는 유용한 솔루션 입니다.
                    </p>
                    :
                    <p>
                        HET-Engine3D is a solution designed for seamless maintenance after engine installation, 
                        providing a variety of management features to meet customer needs, 
                        including end-of-life part notifications, automatic product life notifications, 
                        management document registration, and part-by-part maintenance, 
                        so you can manage the product in time and use it for a long time.
                    </p>
                    }
                    <p>{t("main_section_6")}</p>
                    <div>
                        <div>
                            <button className="moreViewBtn border" onClick={()=>navigate('/contact/inquiry')}>Inquiry</button>
                        </div>
                        <div>
                            <button className="moreViewBtn" onClick={()=>window.open('/LIEBHERR-ENGINE')}>3D Modeling</button>
                        </div>
                    </div>
                </div>
                <div className="imgBox right">
                    <img src="/assets/images/mainSection_3.png" alt="엔진 유지보수관리 솔루션 HET-ENGINE 3D"/>
                </div>
            </div>
        </section>
        </>
    )
}